import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromFaq from '../reducers/faq.reducer';
import { FaqItem } from '../../models';

export const getState = createSelector(fromFeature.getLandingState, (state: fromFeature.FaqCategoriesState) => state.faq);

export const getFaqEntities = createSelector(getState, fromFaq.getFaqEntities);

export const getAllFaq = createSelector(getFaqEntities, entities => {
  return Object.keys(entities).map(slug => entities[slug]);
});

export const getOrderedFaq = createSelector(getAllFaq, faq => {
  return faq.sort(a => a.order);
});

export const getFaqLoaded = createSelector(getState, fromFaq.getFaqLoaded);
export const getFaqLoading = createSelector(getState, fromFaq.getFaqLoading);

export const getFaqGroupedByDepartmentThenCategory = createSelector(getOrderedFaq, groupFaqs);

export function groupFaqs(faq: FaqItem[]) {
  let normalfaq = faq.reduce((acc: { [key: string]: { [key: string]: FaqItem[] } }, cur) => {
    const depName = cur.category?.department?.name;
    const catName = cur.category?.name;
    if (!acc[depName]) {
      acc[depName] = {};
    }
    if (!acc[depName][catName]) {
      acc[depName][catName] = [];
    }
    acc[depName][catName].push(cur);
    return acc;
  }, {});

  // order the categories from every department depending on their first question category order
  Object.keys(normalfaq).forEach(depName => {
    const categories = normalfaq[depName];
    const orderedCategories = Object.keys(categories).sort((a, b) => {
      const aOrder = categories[a][0]?.category?.order || 0;
      const bOrder = categories[b][0]?.category?.order || 0;
      return aOrder - bOrder;
    });
    normalfaq[depName] = orderedCategories.reduce(
      (acc: { [key: string]: FaqItem[] }, catName) => {
        acc[catName] = categories[catName];
        return acc;
      },
      {} as { [key: string]: FaqItem[] }
    );
  });
  return normalfaq;
}
